import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2)
  },
  button: {
    borderRadius: 120,
    padding: 4,
    minWidth: 30,
    maxHeight: 30,
    minHeight: 'auto'
  },
  textField: {
    minWidth: 50,
    maxWidth: 80,
    '& .MuiOutlinedInput-root': { borderRadius: 99 },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontWeight: 600,
      padding: '10px 0',
      color: '#000',
      backgroundColor: '#F8F9FA',
      borderRadius: 99,
      // Hide number input spinners
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&[type=number]': {
        '-moz-appearance': 'textfield'
      }
    }
  },
  oldTextField: {
    minWidth: 50,
    maxWidth: 80,
    '& .MuiOutlinedInput-root': { borderRadius: 8 },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontWeight: 400,
      padding: '10px 0',
      color: '#000',
      backgroundColor: '#ffffff',
      borderRadius: 8,
      // Hide number input spinners
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&[type=number]': {
        '-moz-appearance': 'textfield'
      }
    }
  }
}));
